// configReact/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import ReactGA from 'react-ga4';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
   apiKey: 'AIzaSyAOXLjq2CUVwHmtBwdfQNVxyWkzFu-M9Qg',

   authDomain: 'sassymc85.firebaseapp.com',
   projectId: 'sassymc85',
   storageBucket: 'sassymc85.appspot.com',
   messagingSenderId: '860368639299',
   appId: '1:860368639299:web:1d2ae697f1c308ffb2cbf6',
   measurementId: 'G-S9CJMP9WEP',
};

const app = initializeApp(firebaseConfig);

const analyticGA = () => {
   console.log('process.env.NODE_ENV:', process.env.NODE_ENV);
   if (process.env.NODE_ENV === 'production') {
      console.log('Initialize ReactGA...');
      return getAnalytics(app);
   } else {
      console.log('Initialize ReactGA did not started...');
      return null;
   }
};

// Initialize Firebase

export const auth = getAuth(app);
export const signInWithGoogle = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = analyticGA();
